import { render, staticRenderFns } from "./CabecalhoOrcamento.vue?vue&type=template&id=f1c580d8&scoped=true"
import script from "./CabecalhoOrcamento.vue?vue&type=script&lang=js"
export * from "./CabecalhoOrcamento.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoOrcamento.vue?vue&type=style&index=0&id=f1c580d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c580d8",
  null
  
)

export default component.exports